import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setUnreadNotificationCount } from '../store/actions';

import Header from '../components/common/Header';
import SideBar from '../components/common/SideBar';
import NotificationList from '../components/notification/NotificationList';
import NotificationLeftBox from '../components/notification/NotificationLeftBox';
import NotificationRightBox from '../components/notification/NotificationRightBox';
import NotificationLayout from '../components/notification/NotificationLayout';
import NotificationFilter from '../components/notification/NotificationFilter';
import { GetMyNotificationsService, UpdateNotificationRead } from '../services/NotificationService';
import {
    GetNotificationContentService,
    GetFilteredNotificationService,
    GetMyNotificationOfAvaibality,
} from '../services/NotificationService';
import ReactHtmlParser from 'react-html-parser';
import SkeletonContainer, { getSkeletonHeight } from '../loaders/SekletonContainer';

/** map actions */
function mapDispatchToProps(dispatch) {
    return {
        setUnreadNotificationCount: (payload) => dispatch(setUnreadNotificationCount(payload)),
    };
}

/** map state */
const mapStateToProps = (state) => ({ user: state.user, notification: state.notification });

class NotificationPage extends React.Component {
    mounted = true;
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            Allvisibility: [],
            Unreadvisibility: [],
            Importantvisibility: [],
            NotificationContent: [],
            NotificationAttachments: [],
            notificationTabDef: 'all',
            nId: 0,
            searchFilterText: '',
            isDrawerOpen: !this.props.match.params.id,
        };
    }

    handleToggleDrawer = () => {
        this.setState((prevState) => {
            return {
                isDrawerOpen: !prevState.isDrawerOpen,
            };
        });
    };

    handleSelectNotification = (notificationId) => {
        this.setState({ isDrawerOpen: false });
        this.getNotificationContentMethod(notificationId);
    };

    handleSearchFilterText = (text) => {
        this.setState({ searchFilterText: text });
    };

    checkAvailabilityOfNotification = (notificationTab = 'all') => {
        this.setState({ loading: true });
        try {
            if (this.props.match.params.id) {
                this.setState({ nId: this.props.match.params.id });
                this.getNotificationContentMethod(this.props.match.params.id);
            }
        } catch (error) {}

        GetMyNotificationOfAvaibality(notificationTab).then((res) => {
            if (this.mounted) {
                localStorage.removeItem('unreadNotificationCount');
                localStorage.setItem(
                    'unreadNotificationCount',
                    res.data.notificationsCount ? res.data.notificationsCount.unreadNotificationCount : 0,
                );
                this.props.setUnreadNotificationCount(
                    res.data.notificationsCount ? res.data.notificationsCount.unreadNotificationCount : 0,
                );
                if (notificationTab == 'all') {
                    this.setState({ Allvisibility: res.data.notificationsCount });
                } else if (notificationTab == 'unread') {
                    this.setState({ Unreadvisibility: res.data.notificationsCount });
                } else {
                    this.setState({ Importantvisibility: res.data.notificationsCount });
                }

                this.setState({ loading: false, notificationTabDef: notificationTab });
            }
        });
    };

    componentDidMount() {
        this.checkAvailabilityOfNotification(this.state.notificationTabDef);
    }

    getNotificationContentMethod = (notificationId) => {
        GetNotificationContentService({ notificationId, uId: this.props.user.id })
            .then((res) => {
                this.setState({
                    NotificationContent: res.data.NotificationContents.NotificationContent,
                });

                this.setState({
                    NotificationAttachments: res.data.NotificationContents.attachments,
                });
            })
            .catch((error) => {});

        UpdateNotificationRead({ notificationId, uId: this.props.user.id })
            .then((res) => {
                localStorage.removeItem('unreadNotificationCount');
                localStorage.setItem(
                    'unreadNotificationCount',
                    res.data.NotificationContents.NotificationContent.readNotificationDecrement === true
                        ? this.props.notification.notificationcount - 1
                        : this.props.notification.notificationcount,
                );
                this.props.setUnreadNotificationCount(
                    res.data.NotificationContents.NotificationContent.readNotificationDecrement === true
                        ? this.props.notification.notificationcount - 1
                        : this.props.notification.notificationcount,
                );
            })
            .catch((error) => {});
    };

    componentWillUnmount() {
        this.mounted = false;
    }

    render() {
        return (
            <>
                <Header></Header>
                <div className="content-wrapper d-flex flex-wrap">
                    <SideBar></SideBar>
                    <div className="sidebar-right">
                        <NotificationLayout
                            isDrawerOpen={this.state.isDrawerOpen}
                            onToggleDrawer={this.handleToggleDrawer}
                            sidebar={
                                <div className="notfication-panel">
                                    <NotificationFilter
                                        searchFilterText={this.state.searchFilterText}
                                        handleSearchFilterText={this.handleSearchFilterText}
                                        readStatusRowMethod={this.readStatusMethod}
                                        filterRowMethod={this.filterMethod}
                                        checkNotificationAvailabilityMethod={this.checkAvailabilityOfNotification}
                                    />

                                    {this.state.loading && <SkeletonContainer height={getSkeletonHeight(3)} />}

                                    {!this.state.loading && (
                                        <NotificationLeftBox
                                            // Available tab
                                            AllvisibilityTab={this.state.Allvisibility}
                                            UnreadvisibilityTab={this.state.Unreadvisibility}
                                            ImportantvisibilityTab={this.state.Importantvisibility}
                                            notificationTabDef={this.state.notificationTabDef}
                                            //Content method
                                            searchFilterText={this.state.searchFilterText}
                                            handleSearchFilterText={this.handleSearchFilterText}
                                            parentGetNotificationContent={this.handleSelectNotification}
                                            parentGetMyNotification={this.getMyNotification}
                                            filteredNotificationRow={this.state.filteredNotification}
                                            filterRowMethod={this.filterMethod}
                                            nId={this.state.nId}
                                        />
                                    )}
                                </div>
                            }
                        >
                            <NotificationRightBox
                                notificationContent={this.state.NotificationContent}
                                notificationAttachment={this.state.NotificationAttachments}
                            />
                        </NotificationLayout>
                    </div>
                </div>
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationPage);
